module.exports = __webpack_public_path__ + "img/magento-modules-customization@2x.71e7f445.webp";